module.exports = __webpack_public_path__ + "static/rowIcon2.28603d62.svg";